import "./footer.css";
import IMAGES from "../../images/images";
import { Link } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";

export default function Footer() {
    return (
        <div className="footer__box">
            <div className="footerIcons__box">
                <div className="footerIcons">
                    <div className="footerIcons__wrapper">
                        <a href="https://github.com/ArcOmotola" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.githubIcon} alt="" />
                        </a>
                        <a href="https://twitter.com/omo_t_quantum" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.twitter} alt="" />
                        </a>
                        <a href="https://www.instagram.com/p/CKyBE2ZFdEC/?utm_medium=copy_link" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.instagram} alt="" />
                        </a>
                        <a href="https://www.linkedin.com/in/omotola-ogunsola-13a60710b" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.linkedIn} alt="" />
                        </a>
                    </div>
                    
                    <div className="footerText__links">
                        <Link className="footer__item" to="/">
                            <h3>Home</h3>
                        </Link>
                        <Link className="footer__item" to="/about">
                            <h3>About</h3>
                        </Link>
                        <NavHashLink
                            smooth
                            className="footer__item"
                            to="/#portfolio"
                            activeClassName="selected">
                            <h3>Portfolio</h3>
                        </NavHashLink>
                        <Link className="footer__item" to="/blog">
                            <h3>Blog</h3>
                        </Link>
                        <Link className="footer__item" to="/contact">
                            <h3>Contact</h3>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="footerText__wrapper">
                    
                <h2>© 2022 Omotola Ogunsola - All rights reserved</h2>
            </div>
        </div>
    )
}
